/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserGroupAssignment } from './UserGroupAssignment';
import {
    UserGroupAssignmentFromJSON,
    UserGroupAssignmentFromJSONTyped,
    UserGroupAssignmentToJSON,
} from './UserGroupAssignment';

/**
 * 
 * @export
 * @interface UserGroup
 */
export interface UserGroup {
    /**
     * 
     * @type {string}
     * @memberof UserGroup
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroup
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroup
     */
    description?: string;
    /**
     * 
     * @type {Array<UserGroupAssignment>}
     * @memberof UserGroup
     */
    assignments?: Array<UserGroupAssignment>;
}

/**
 * Check if a given object implements the UserGroup interface.
 */
export function instanceOfUserGroup(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function UserGroupFromJSON(json: any): UserGroup {
    return UserGroupFromJSONTyped(json, false);
}

export function UserGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'assignments': !exists(json, 'assignments') ? undefined : ((json['assignments'] as Array<any>).map(UserGroupAssignmentFromJSON)),
    };
}

export function UserGroupToJSON(value?: UserGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'assignments': value.assignments === undefined ? undefined : ((value.assignments as Array<any>).map(UserGroupAssignmentToJSON)),
    };
}

